module.exports = __webpack_public_path__ + "static/img/13.5c28d18.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/VascularSystem/Meeting602/images/13.png
// module id = MHSn
// module chunks = 4